import React from 'react';
import { Card } from '../ui/Card';
import { ShieldCheckIcon, AlertTriangleIcon } from 'lucide-react';
interface PolicyRule {
  type: 'allow' | 'deny' | 'limit';
  description: string;
}
interface PolicySummaryProps {
  rules: PolicyRule[];
  mode: 'default-deny' | 'default-allow';
}
export function PolicySummary({
  rules,
  mode
}: PolicySummaryProps) {
  return <Card padding="sm" data-id="element-56">
      <div className="flex items-center gap-2 mb-3" data-id="element-57">
        <ShieldCheckIcon className="h-4 w-4 text-blue-600 dark:text-blue-500" data-id="element-58" />
        <span className="text-sm font-semibold text-slate-900 dark:text-slate-100" data-id="element-59">
          Policy Summary
        </span>
        <span className="text-xs px-2 py-0.5 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 rounded" data-id="element-60">
          {mode === 'default-deny' ? 'Default Deny' : 'Default Allow'}
        </span>
      </div>
      <ul className="space-y-2" data-id="element-61">
        {rules.map((rule, index) => <li key={index} className="flex items-start gap-2 text-xs" data-id="element-62">
            <span className={`
                mt-0.5 h-1.5 w-1.5 rounded-full flex-shrink-0
                ${rule.type === 'allow' ? 'bg-green-500 dark:bg-green-400' : rule.type === 'deny' ? 'bg-red-500 dark:bg-red-400' : 'bg-amber-500 dark:bg-amber-400'}
              `} data-id="element-63" />
            <span className="text-slate-700 dark:text-slate-300" data-id="element-64">
              {rule.description}
            </span>
          </li>)}
      </ul>
    </Card>;
}